import { axiosGet } from '@/api/handlers';
import { getQueryClient } from '@/lib/react-query';
import {
  CorporatesModel,
  type CorporatesModelType,
  type GovernmentSearchSettingFormValues,
} from '../_models/government-search';
import {
  type FetchGovernmentNumberParams,
  type FetchGovernmentParams,
  governmentSearchQueryKeyMap,
} from '../_utils/query-keys';

export const PAYMENT_SEARCH_SETTING_DEFAULT_VALUES: GovernmentSearchSettingFormValues =
  {
    matchType: 'partial-match',
    includeHistorySearch: false,
    includeClosedCorporation: true,
  };

export const fetchGovernment = (
  params: FetchGovernmentParams,
): Promise<CorporatesModelType[]> => {
  return getQueryClient().fetchQuery<CorporatesModelType[]>({
    queryKey: governmentSearchQueryKeyMap.government(params),
    queryFn: async () => {
      const res = await axiosGet('/api/government-api/corporates/', params);
      return CorporatesModel.parse(res);
    },
  });
};

export const fetchGovernmentNumber = (
  params: FetchGovernmentNumberParams,
): Promise<CorporatesModelType[]> => {
  return getQueryClient().fetchQuery<CorporatesModelType[]>({
    queryKey: governmentSearchQueryKeyMap.governmentNumber(params),
    queryFn: async () => {
      const res = await axiosGet(
        '/api/government-api/corporate-by-number/',
        params,
      );
      return CorporatesModel.parse(res);
    },
  });
};
